import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { MdCheck, MdOutlineCheckCircle, MdOutlineCircle, MdOutlineCopyAll } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import SingleLoaderItem from "../Loaders/SingleLoaderItem";
import { BiError, BiNetworkChart, BiStar } from "react-icons/bi";
import { BsFillStarFill, BsStar } from "react-icons/bs";
import { PiPlugs, PiPlugsConnected } from "react-icons/pi";
import { TbReload } from "react-icons/tb";
import { ImNewTab } from "react-icons/im";
import { useLanguage } from "../Translations/LenguageContext";

const AbilitiesModal = ({
    account_id,
    show,
    handleClose,
    mcpData,
    fetchMcpData,
    loadingMcpData,
    connectors,
    setConnectors,
    handleOpenConnect,
    handleOpenDisconnect,
    setSelectedMcp,
    setOpenErrDepModal
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { org_id } = useParams()

    useEffect(() => {
        if (show) {
            fetchMcpData(org_id)
        }
    }, [show])

    return (
        <Modal show={show} centered onHide={handleClose}>
            <div className="modal_header">
                <p className="modal_header_title">{t.playground.all_abilities}</p>
            </div>

            <div className="modal_main_cont">
                {loadingMcpData ? (
                    <SingleLoaderItem length={3} />
                ) : (
                    mcpData.length > 0 ? (
                        <div className="modal_connectors_cont">
                            {mcpData.map((mcp) => {
                                const isChecked = connectors.some(conn => conn.id === mcp.id);

                                const handleToggle = () => {
                                    if (isChecked) {
                                        setConnectors(connectors.filter((conn) => conn.id !== mcp.id));
                                    } else {
                                        const newConnector = {
                                            id: mcp.id,
                                            name: mcp.name,
                                            type: mcp.type || 'mcp'
                                        };
                                        setConnectors([...connectors, newConnector]);
                                    }
                                };

                                return (
                                    <div className="sidebar_label_wrapper_row fade-in" key={mcp.id}>
                                        <label className="sidebar_choise_btn_title" htmlFor={mcp.id}>
                                            <span className="sidebar_choise_btn_title_span">
                                                {mcp.name}

                                                {mcp.tag && (
                                                    <span className="model_name_tag">{mcp.tag}</span>
                                                )}
                                            </span>

                                            {mcp.is_version_different && (
                                                <span className="version_alert">
                                                    <MandatorySign
                                                        message={"The deployed version and your connected version differ. We recommend reconnecting to sync them."}
                                                        icon="info"
                                                    />
                                                </span>
                                            )}
                                        </label>

                                        {mcp.is_connected ? (
                                            <button
                                                className="disconnect_btn_modal"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedMcp(mcp);
                                                    handleOpenDisconnect(mcp.system_provider);
                                                }}
                                            >
                                                {t.disconnect} <PiPlugs />
                                            </button>
                                        ) : (
                                            mcp.status_deployment == "DEPLOYING" ? (
                                                <button
                                                    className="disconnect_btn_modal"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        fetchMcpData(org_id)
                                                    }}

                                                >
                                                    <TbReload />
                                                </button>
                                            ) : mcp.status_deployment != "DEPLOYED" ? (
                                                <button
                                                    className="disconnect_btn_modal"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setOpenErrDepModal(true)
                                                    }}

                                                >
                                                    <BiError />
                                                </button>
                                            ) : (
                                                mcp.version && (

                                                    <button
                                                        className="connect_btn_modal"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedMcp(mcp);
                                                            handleOpenConnect(mcp.system_provider)
                                                        }}
                                                    >
                                                        {t.connect} <PiPlugsConnected />
                                                    </button>
                                                )
                                            )

                                        )}

                                    </div>
                                )
                            })}
                        </div>
                    ) : (
                        <div className="empty_ability_cont">
                            <div className="organizations_cont_no_items_mex fade-in">
                                {t.no_abilities}
                            </div>
                            <div className="confirmation_ability_get_btn_cont">
                             <a
                                href="/directories/abilities"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="confirmation_ability_get_btn"
                            >
                                <span><ImNewTab /> {t.open_directory}</span>
                            </a>
                            </div>
                        </div>
                    )
                )}

            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default AbilitiesModal;